// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CrossComponent} from './Cross.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCross = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CrossComponent/>
  </Icon>
));
